export const belongStandardsItems = [
  {
    imageUrl: '/improvement-reports/belong_standard_02.png',
    title: 'Safety & Security',
    body: 'We will always flag items we deem unsafe to minimize liability and keep your home and your residents safe.',
  },
  {
    imageUrl: '/improvement-reports/belong_secret_sauce.jpg',
    title: 'Belong’s Secret Sauce',
    body: 'These are items we are confident that increase the likelihood of your home getting loved quicker, reduce maintenance costs, and your residents staying longer in your home.',
  },
  {
    imageUrl: '/improvement-reports/belong_standard_03.png',
    title: 'Recommendations',
    body: 'These are optional repairs that have direct impact on your resident’s experience and will make your home shine. These are additional investments but provide strong return on investment.',
  },
];

export const wearAndTearItems = [
  {
    imageUrl: '/post_inspection/responsibility/wear_tear_banner_wall.jpg',
    beforeUrl:
      '/post_inspection/responsibility/wear_tear_compare_wall_normal.jpg',
    afterUrl:
      '/post_inspection/responsibility/wear_tear_compare_wall_excessive.jpg',
    beforeText: 'A Few Small Tack Or Nail Holes In The Wall',
    afterText: 'Two-Inch Diameter Hole In Wall Or Ceiling',
    title: 'Wall Damage',
  },
  {
    imageUrl: '/post_inspection/responsibility/wear_tear_banner_floor.jpg',
    beforeUrl:
      '/post_inspection/responsibility/wear_tear_compare_floor_normal.jpg',
    afterUrl:
      '/post_inspection/responsibility/wear_tear_compare_floor_excessive.jpg',
    beforeText: 'Minor Scuff Marks Or Small Chips In Floor',
    afterText: 'Large Scuff Marks, Gouges Or Tears In Floor',
    title: 'Floor Damage',
  },
  {
    imageUrl: '/post_inspection/responsibility/wear_tear_banner_clutter.jpg',
    beforeUrl:
      '/post_inspection/responsibility/wear_tear_compare_clutter_normal.jpg',
    afterUrl:
      '/post_inspection/responsibility/wear_tear_compare_clutter_excessive.jpg',
    beforeText: 'Less Than A Few Small Items Left Behind',
    afterText: 'More Than A Few Items Or Large Items That Require Hauling',
    title: 'Clutter',
  },
  {
    imageUrl: '/post_inspection/responsibility/wear_tear_banner_pet.jpg',
    beforeUrl:
      '/post_inspection/responsibility/wear_tear_compare_pet_normal.jpg',
    afterUrl:
      '/post_inspection/responsibility/wear_tear_compare_pet_excessive.jpg',
    beforeText: 'Carpets Or Furniture Worn Thin By Normal Use',
    afterText: 'Urine Stains Or Tears In Carpets Or Furniture From Pets',
    title: 'Pet Damage',
  },
  {
    imageUrl: '/post_inspection/responsibility/wear_tear_banner_lighting.jpg',
    // Image names are backwards here, don't wanna change the name here because drive is gonna be wrong.
    beforeUrl:
      '/post_inspection/responsibility/wear_tear_compare_lighting_excessive.jpg',
    afterUrl:
      '/post_inspection/responsibility/wear_tear_compare_lighting_normal.jpg',
    beforeText: 'Wiring Or Underlying Electrical Issues, Resecuring Fixtures',
    afterText: 'Missing Or Non-Functional Light Bulbs',
    title: 'Lighting',
  },
  {
    imageUrl: '/post_inspection/responsibility/wear_tear_banner_bathroom.jpg',
    beforeUrl:
      '/post_inspection/responsibility/wear_tear_compare_bathroom_normal.jpg',
    afterUrl:
      '/post_inspection/responsibility/wear_tear_compare_bathroom_excessive.jpg',
    beforeText: 'Discoloration Or Deterioration Of Existing Caulking Or Grout',
    afterText: 'Broken Tiles Or Structural Damage To Tub Or Toilet',
    title: 'Bathroom Damage',
  },
  {
    imageUrl: '/post_inspection/responsibility/wear_tear_banner_blinds.jpg',
    beforeUrl:
      '/post_inspection/responsibility/wear_tear_compare_blinds_normal.jpg',
    afterUrl:
      '/post_inspection/responsibility/wear_tear_compare_blinds_excessive.jpg',
    beforeText: 'Dusty Blinds Or Pull String Mechanism Doesn’t Work',
    afterText: 'Missing Or Broken Blind Slats, Shading Rod Broken Or Missing',
    title: 'Blinds',
  },
  {
    imageUrl: '/post_inspection/responsibility/wear_tear_banner_electrical.jpg',
    beforeUrl:
      '/post_inspection/responsibility/wear_tear_compare_electrical_normal.jpg',
    afterUrl:
      '/post_inspection/responsibility/wear_tear_compare_electrical_excessive.jpg',
    beforeText: 'Outlets Not Working, Open Ground, Or Wiring Erosion',
    afterText: 'Broken Or Damaged Receptacle Cover, Broken Toggle Switches',
    title: 'Electrical',
  },
  {
    imageUrl: '/post_inspection/responsibility/wear_tear_banner_appliances.jpg',
    beforeUrl:
      '/post_inspection/responsibility/wear_tear_compare_appliances_normal.jpg',
    afterUrl:
      '/post_inspection/responsibility/wear_tear_compare_appliances_excessive.jpg',
    beforeText: 'Cosmetic Damages Such As Minor Scratches Or Blemishes',
    afterText: 'Functional Damage Such As Missing Handles Or Broken Components',
    title: 'Appliances',
  },
  {
    imageUrl:
      '/post_inspection/responsibility/wear_tear_banner_landscaping.jpg',
    beforeUrl:
      '/post_inspection/responsibility/wear_tear_compare_landscaping_normal.jpg',
    afterUrl:
      '/post_inspection/responsibility/wear_tear_compare_landscaping_excessive.jpg',
    beforeText: 'Overgrown Weeds, Dry Spots In Grass, Or Under Watered Plants',
    afterText: 'Torn Up Lawn, Missing Or Damaged Plants And Flowers',
    title: 'Landscaping',
  },
];
